module.exports = __webpack_public_path__ + "static/media/vacctrak_passes.736d4004.png";